// Gedeelde week-helpers voor de planningspagina's.
// Elke pagina had een eigen kopie van getMonday/formatDateISO/getWeekNumber; die liepen
// uiteen (zondag-afhandeling, weeknummer). Eén bron voorkomt dat pagina's een andere week
// tonen voor dezelfde datum.

/** Maandag van de week waarin `date` valt, op lokale middernacht. */
export function getMonday(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay(); // 0 = zondag
  d.setDate(d.getDate() + (day === 0 ? -6 : 1 - day));
  return d;
}

export function addDays(date, aantal) {
  const d = new Date(date);
  d.setDate(d.getDate() + aantal);
  return d;
}

/** YYYY-MM-DD in de LOKALE tijdzone (toISOString zou in CEST een dag terug kunnen schuiven). */
export function formatDateISO(date) {
  const d = new Date(date);
  const maand = String(d.getMonth() + 1).padStart(2, '0');
  const dag = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${maand}-${dag}`;
}

/** Omgekeerde van formatDateISO. `new Date('2026-08-12')` is UTC en schuift wél. */
export function parseISODate(iso) {
  const [jaar, maand, dag] = String(iso || '').split('-').map(Number);
  if (!jaar || !maand || !dag) return null;
  return new Date(jaar, maand - 1, dag);
}

/** ISO-8601 weeknummer (week 1 = de week met de eerste donderdag). */
export function getWeekNumber(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  // Naar de donderdag van deze week: dan valt het jaar altijd goed.
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));
  const eersteDonderdag = new Date(d.getFullYear(), 0, 4);
  eersteDonderdag.setDate(eersteDonderdag.getDate() + 3 - ((eersteDonderdag.getDay() + 6) % 7));
  return 1 + Math.round((d - eersteDonderdag) / (7 * 24 * 60 * 60 * 1000));
}

const MAANDEN = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

/** "Week 33 · 10 – 16 aug" of, bij meerdere weken, "Week 33–34 · 10 – 23 aug". */
export function formatWeekLabel(weekStart, rangeWeeks = 1) {
  const start = getMonday(weekStart);
  const eind = addDays(start, rangeWeeks * 7 - 1);
  const weekNr = getWeekNumber(start);
  const weekDeel = rangeWeeks > 1 ? `Week ${weekNr}–${getWeekNumber(eind)}` : `Week ${weekNr}`;
  const datumDeel = start.getMonth() === eind.getMonth()
    ? `${start.getDate()} – ${eind.getDate()} ${MAANDEN[eind.getMonth()]}`
    : `${start.getDate()} ${MAANDEN[start.getMonth()]} – ${eind.getDate()} ${MAANDEN[eind.getMonth()]}`;
  return `${weekDeel} · ${datumDeel}`;
}

/** True als `date` in dezelfde week valt als vandaag. */
export function isCurrentWeek(date) {
  return formatDateISO(getMonday(date)) === formatDateISO(getMonday(new Date()));
}
